// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"127":"fbad5e06","154":"9ea603c7","162":"d991f30c","492":"9c9d5b80","564":"9a82b243","864":"0a36fb4d"}[chunkId] + ".css";
};